<template>
<div class="chapter">
<div class="inner_page">
<p><a id="frw"></a></p>
<div class="fmhT"><b>Foreword</b></div>
<div class="fmtx1">The Project Manager’s Spotlight Series is written for those of you who are engaged in projects at the day-to-day level of business. You’re working on projects such as server consolidation, piloting new products in the marketplace, or opening a new branch or storefront. These day-to-day projects keep businesses moving forward, carving out market share, meeting strategic goals, and improving the firm’s bottom line. These projects, while vitally important to the companies you work for, are not necessarily multi-million dollar, multi-year projects that require meticulous disciplines and precise methodologies.</div>
<div class="fmtx">The Project Manager’s Spotlight Series shows you the how-to’s of project management on a practical level. These books help you apply solid principles of project management without the rigor. You’ll find tools, tips, and techniques to help you use Project Management Institute-based practices in your small- to medium-sized projects; these are tips you can read over the weekend and be ready and able to apply on Monday morning.</div>
<div> <br/></div><div class="fmtx">—Kim Heldman</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// held_9781118000229_oeb_frw_r1.vue?3b6e8098